import { DialogSurfaceThemeProvider } from '../ui/dialog-surface-theme';
import { ContentContainer } from './ContentContainer';
import { MainFooter } from './MainFooter';
import { MainNav } from './MainNav';

/** Guest auth routes — light stone + teal (`[data-app-theme="auth"]`), not marketing shell. */
export function AuthPublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div
      className='flex min-h-screen flex-col bg-background text-foreground'
      data-app-theme='auth'
    >
      <DialogSurfaceThemeProvider value='auth'>
        <MainNav />
        <main className='flex min-h-0 flex-1 flex-col'>
          <ContentContainer className='py-6 sm:py-8'>{children}</ContentContainer>
        </main>
        <MainFooter />
      </DialogSurfaceThemeProvider>
    </div>
  );
}
